// Helper aditivo B-01 fase 8 (post-QA feb-2026).
// Coerción defensiva para campos escalares que podrían llegar como objeto (fixtures/seeds
// heredados) y que hoy se pintan directo en JSX como texto.
//
// Idéntico criterio al helper `domicilio.js`: no cambia lógica de negocio, no toca datos,
// no modifica archivos sellados. Su único trabajo es garantizar que la UI reciba SIEMPRE
// un string imprimible aunque el dato venga en forma inesperada.
//
// Casos:
//   - null / undefined                              → ""
//   - string                                        → trim
//   - number / boolean                              → String(v)
//   - objeto vacío o con llaves en blanco           → "" (nunca pares vacíos)
//   - objeto con llaves { clave: valor }            → "clave: valor, clave2: valor2"
//   - array                                         → join(", ") de items no vacíos
//
// No es específico de ningún campo: sirve como blindaje genérico contra el patrón
// "asumir string sin verificar tipo" detectado en el commit 7506774.
export function safeText(v) {
  if (v == null) return "";
  if (typeof v === "string") return v.trim();
  if (typeof v === "number" || typeof v === "boolean") return String(v);
  if (Array.isArray(v)) {
    return v.map((x) => safeText(x)).filter(Boolean).join(", ");
  }
  if (typeof v === "object") {
    const partes = [];
    for (const [k, val] of Object.entries(v)) {
      const s = safeText(val);
      if (s) partes.push(`${k}: ${s}`);
    }
    return partes.join(", ");
  }
  return String(v);
}
